import { Stack } from '@mui/material';

import { BlockValueTemplateField } from '../../ConfigFields/CodeMirror/FlowTemplate.tsx';

export function RealTimeEligibilityFormFields() {
  return (
    <Stack direction="column" spacing={2}>
      <BlockValueTemplateField
        fieldName="config.patientInsuranceInformationId"
        label="Patient Insurance Information ID"
      />
      <BlockValueTemplateField fieldName="config.npi" label="National Provider Identifier (NPI)" />
    </Stack>
  );
}
